/*=============================================================================
FAQ ACCORDION
=============================================================================*/

document.addEventListener('click', (event) => {

    const trigger = event.target.closest('.vbl-faq-item__trigger');

    if (!trigger) return;

    const panel = document.getElementById(
        trigger.getAttribute('aria-controls')
    );

    if (!panel) return;

    const expanded = trigger.getAttribute('aria-expanded') === 'true';

    // Close all FAQ items
    document.querySelectorAll('.vbl-faq-item__trigger').forEach((button) => {

        button.setAttribute('aria-expanded', 'false');

    });

    document.querySelectorAll('.vbl-faq-item__content').forEach((content) => {

        content.hidden = true;

    });

    // Open the selected item
    if (!expanded) {

        trigger.setAttribute('aria-expanded', 'true');

        panel.hidden = false;

    }

});
